module.exports = __webpack_public_path__ + "static/media/pickle.1dbdb257.png";